import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { Colors, FontWeights } from '../../constants'

interface Props {
  className?: string
}

export function PoolNavigation({ className }: Props) {
  return (
    <Content className={className}>
      <Link to="/deposit">
        <span>Deposit</span>
      </Link>
      <Link to="/withdraw">
        <span>My Pools</span>
      </Link>
    </Content>
  )
}

const Content = styled.div`
  display: flex;
  border-bottom: 1px solid #c4c4c4;
`

const Link = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-basis: 50%;
  text-align: center;
  height: 42px;
  color: ${Colors.LighterGray};
  font-size: 15px;
  font-weight: ${FontWeights.Bold};
  text-transform: uppercase;
  text-decoration: none;
  border-right: 1px solid #c4c4c4;
  background: rgb(239, 239, 239);
  background: linear-gradient(0deg, rgba(239, 239, 239, 1) 0%, rgba(229, 229, 229, 1) 100%);

  &:last-child {
    border-right: 0;
  }

  &.active {
    color: ${Colors.Black};
    background: ${Colors.White};
  }

  &:hover {
    color: ${Colors.Hover};
  }
`
